//import logger from "kernel/logger/Logger";

/**
 * @module clientconfig/ClientConfig
 * @memberof kernel
 * @description Manages loading and parsing of embedded config on Gateway Page
 */

	var clientConfig = {}; //'default' exports don't seem to access data that can change.
	//any function that has a thing like a full clientConfig or object to access, name the export

	//In case we just want to import an individual node instead of the whole config?
	var consoleConfig = {};
	var deviceConfig = {};
	var gameConfig = {};
	var gameServiceConfig = {};
	var kernelConfig = {};
	var serverConfig = {};
	var stringsConfig = {};
	var widgetConfig = {};


	function localLoadClientConfig(success, fail){
		var config, jSessionId;
		// Capture reference to client config
		var element = document.getElementsByName('com.igt.skateboard.CLIENTCONFIG')[0];

		if(!element){
			fail();
			return;
		}

		// Parse the client config element
		if(element && element.content){
			config = JSON.parse(element.content);
		} else{
			throw new Error('Missing or malformed element com.igt.skateboard.CLIENTCONFIG');
		}

		// For RGS 5.4 - get correct session id from clientconfig
		if(config.serverConfig['sessionToken']){
			config.serverConfig['IGTJSESSIONID'] = config.serverConfig['sessionToken'];
		}

		//POC - replace a few parameters TODO - remove before release
		/*
		if (config.serverConfig.paramGet && config.serverConfig.paramGet.gameUrl) {
			config.serverConfig.gameUrl = config.serverConfig.paramGet.gameUrl;
		}
		if (config.serverConfig.paramGet && config.serverConfig.paramGet.thirdPartyCode) {
			config.serverConfig.thirdPartyCode = config.serverConfig.paramGet.thirdPartyCode;
		}
		*/


		// Delete the config element from the page after consuming
		element.parentNode.removeChild(element);

		// SKATE-438 Add localised strings for 'Balance' as it doesn't exist in RGS strings right now
		if(!config.stringsConfig.hasOwnProperty('Balance')){
			config.stringsConfig["Balance"] = {
				"da": "Saldo",
				"de": "Guthaben",
				"el": "Υπολοιπο",
				"es-mx": "Saldo",
				"es": "Saldo",
				"fi": "Saldo",
				"fr-ca": "Solde",
				"fr": "Solde",
				"hu": "Egyenleg",
				"it": "Saldo",
				"no": "Saldo",
				"pl": "Saldo",
				"pt": "Saldo",
				"ro": "Sold",
				"sv": "Saldo"
			};
		}
		if (config.serverConfig.thirdPartyCode) {
			config.kernelConfig.splashUrl = void (0); //No Splashy Splash
			config.serverConfig.paramGame.skbVersion = SKB_VERSION_TOKEN;
		}
		success(config);
	}

	function updateSingleExports() {
		consoleConfig = clientConfig.consoleConfig || {};
		deviceConfig = clientConfig.deviceConfig || {};
		gameConfig = clientConfig.gameConfig || {};
		gameServiceConfig = clientConfig.gameServiceConfig || {};
		kernelConfig = clientConfig.kernelConfig || {};
		serverConfig = clientConfig.serverConfig || {};
		stringsConfig = clientConfig.stringsConfig || {};
		widgetConfig = clientConfig.widgetConfig  || {};
	}

	function normalizeConsoleConfig(config){
		//Copy root console param white list and lobbyUrl into subnodes for console
		//Duplicating this data from RGS side could add overhead as we're passing up to 5 times the expected data.
		//TODO - instead of adding to subnodes, make the code read the root node?  If not, leave this as is
		var consolePieces = ["TCustomView", "BCustomView", "LCustomView", "RCustomView"];

		consolePieces.forEach(function(consolePiece) {
			if (config.consoleConfig[consolePiece]) {
				config.consoleConfig[consolePiece].lobbyUrl = config.consoleConfig.lobbyUrl;
				config.consoleConfig[consolePiece].consoleParamWhitelist = config.consoleConfig.consoleParamWhitelist;
			}
		});
        /* devblock:start */
		var gatAllowList = [
			'test_api_endpoint',
			'test_module_url',
			'test_job',
			'test_platform',
			'test_emulation',
			'test_disable_on_screen_logs',
			'test_translation_check'
		];
		gatAllowList.forEach(function (param) {
			if (config.serverConfig.paramGet && config.serverConfig.paramGet[param]) {
				config.serverConfig.paramGame[param] = config.serverConfig.paramGet[param];
			}
		});
        /* devblock:end */
		return config;
	}

	function showFatalError(message){
		//console.log(message);
		if (document.getElementById('loader')) {
			document.getElementById('loader').style.visibility='hidden';
		}
		if (document.getElementById('messageBoxDiv')) { //added because of broken unit tests
			document.getElementById('messageBoxDiv').style.visibility='visible';
		}
		if (document.getElementById('message')) { //added because of broken unit tests
			document.getElementById('message').innerHTML = message;
		}

		var container = document.getElementById('container');
		if (container) { //This may occur before anything even happens
			container.parentNode.removeChild(container);
		}
	}

	/**
	 * @function load
	 * @description Getter for the client configuration data
	 * @param done {Function} callback to execute on completion; this callback will receive the config
	 * @returns {object} config The Client Configuration Object - passed to the done function callback
	 */
	function load(done){
		//no breaking the reference for all imports, so we can update the clientConfig object
		localLoadClientConfig(function successLocalLoad(config){
			Object.assign(clientConfig, normalizeConsoleConfig(config));
			updateSingleExports();
			done(clientConfig);
		}, function failServerLoad(reason){ //SKATE-6315 remove local iOS parse
			if(!reason){
				reason = "System Error";
			}
			showFatalError(reason);
		});
	}

	export { load };

	//individual exports, in case we want functions that just need deviceConfig, or stringsConfig
	export { consoleConfig, deviceConfig, gameConfig, gameServiceConfig, kernelConfig, serverConfig, stringsConfig, widgetConfig };

	export { clientConfig };

/*
NAMED EXPORTS ONLY for client config
export default function getClientConfig(){
	return clientConfig;
};
 */
//Should we remove a 'default' as default doesn't really work?

